<div> 
    <app-analise-hora-bi05-filtro
          [filtros]="filtros">
    </app-analise-hora-bi05-filtro>
    <app-analise-hora-bi05-lista
          [filtros]="filtros"
          (definirFiltro)="definirFiltro()"
          (exibir)="selecionar($event)">
    </app-analise-hora-bi05-lista>
   </div>